import React from "react";
import { X } from "lucide-react";

const ErrorMessage = ({ message, onDismiss, className = "" }) => (
  <div
    className={`p-4 bg-red-50 border border-red-200 rounded-lg ${className}`}
  >
    <div className="flex justify-between items-center">
      <p className="text-red-800">{message}</p>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="text-red-600 hover:text-red-800 ml-4"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  </div>
);


export default ErrorMessage